mutation createImageDetailsReportMutation {
    createImageDetailsReport
}